import { useEffect, useMemo, useState } from 'react';

import { useVoiceNoteTemplates } from '@/react-query/videa-notes/useVoiceNoteTemplates';

import type { VoiceNoteTemplateOption } from '../types';

/**
 * Hook for managing template selection in Videa Notes.
 * Selects the first template in the list by default when options load.
 */
export const usePromptTemplateSelection = () => {
  const { data: voiceNoteTemplates = [] } = useVoiceNoteTemplates();

  const [selectedTemplate, setSelectedTemplate] = useState<string | undefined>(
    undefined,
  );

  const templateOptions: VoiceNoteTemplateOption[] = useMemo(
    () =>
      voiceNoteTemplates.map((template) => ({
        id: template.id,
        name: template.name,
        type: template.type,
        userInstructions: template.userInstructions,
      })),
    [voiceNoteTemplates],
  );

  // Select first template by default when options are available
  useEffect(() => {
    if (templateOptions.length > 0 && selectedTemplate === undefined) {
      setSelectedTemplate(templateOptions[0].id);
    }
  }, [templateOptions, selectedTemplate]);

  return {
    templateOptions,
    selectedTemplate,
    setSelectedTemplate,
  };
};
